import { Typography } from '@sravni/react-design-system';
import React from 'react';

import { LottieLoader } from 'shared/ui/lottie.loader';

import { SELECTION_OFFERS_TEXT } from 'features/SlidesLoader/config';

import animationData from '../../config/animations/selection.json';

import styles from './styles.module.scss';

export const SelectionLoad: React.FC = () => {
  return (
    <div className={styles.wrapper}>
      <LottieLoader
        className={styles.imageContainer}
        options={{ animationData }}
        height={150}
      />
      <Typography.Heading
        className={styles.heading}
        level={4}
      >
        {SELECTION_OFFERS_TEXT}
      </Typography.Heading>
    </div>
  );
};
